<template>
  <div
    class="center-panel"
    :style="background"
  >
    <div class="middle">
      <div
        class="inner"
        :style="panelStyle"
      >
        <slot />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CenterPanel',
  props: {
    panelStyle: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      background: ''
    }
  },
  beforeMount () {
    if (this.$store.state.background === 'tobeset') {
      this.background = { 'background-image': 'none' }
    } else {
      this.background = { 'background-image': 'url(' + this.$store.state.background + ')' }
    }
  }
}
</script>

<style lang="scss" scoped>
.center-panel {
  display: table;
  position: absolute;
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-image: url('../../assets/website-dots.png');
  background-position: center 0px;
  background-size: cover;

  .middle {
    display: table-cell;
    vertical-align: middle;

    .inner {
      margin: 0 auto;
      width: 375px;
      max-width: 100vw;
      border-radius: 5px;
      box-shadow: 0px 0px 10px 5px rgba(81, 167, 249, 0.1);
      display: flex;
      flex-direction: column;
      overflow: hidden;
    }
  }
}

@media only screen and (max-width: 400px) {
  .middle{
    .inner {
      height: 100vh;
      max-height: 100vh;
    }
  }
}

</style>
